import React from 'react';
import { CardDisplay } from './CardDisplay';

export interface TrickPlay {
  playerName: string;
  card: { suit: string; rank: string };
  isWinner?: boolean;
  note?: string;
}

interface TrickExampleProps {
  trumpSuit: string;
  leadSuit: string;
  plays: TrickPlay[];
  explanation: string;
}

export function TrickExample({
  trumpSuit,
  leadSuit,
  plays,
  explanation,
}: TrickExampleProps) {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 my-6">
      <div className="flex items-center gap-2 mb-4 text-sm text-gray-600">
        <span className="font-medium">Trump: {trumpSuit}</span>
        <span>•</span>
        <span className="font-medium">Lead: {leadSuit}</span>
      </div>
      <div className="grid grid-cols-4 gap-4 mb-4">
        {plays.map((play, i) => (
          <div
            key={i}
            className={`text-center p-3 rounded ${
              play.isWinner
                ? 'bg-green-100 border-2 border-green-500'
                : 'bg-white border border-gray-200'
            }`}
          >
            <div className="text-sm font-medium mb-2 text-black">
              {play.playerName}
            </div>
            <CardDisplay suit={play.card.suit as any} rank={play.card.rank} />
            {play.note && (
              <div className="text-xs text-gray-600 mt-2">{play.note}</div>
            )}
            {play.isWinner && (
              <div className="text-xs font-semibold text-green-700 mt-2">
                ✓ Winner
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="text-sm text-gray-700 bg-white p-3 rounded border">
        <strong>Result:</strong> {explanation}
      </div>
    </div>
  );
}
